(function( $ ) {
    "use strict";
    var Shipping = {
        country: 'Brazil'
    };

    Shipping.init = function() {
        Shipping.state = null;
        Shipping.cep = null;
        $('#shipping-rates-feedback').html('');
        $('#shipping-rates').html('');
    }

    Shipping.clearCart = function () {
        return new Promise((resolve, reject) => {
            console.log('Shipping: Clearing cart');
            $.post("/cart/clear.js", function (data) {
                console.log("Shipping: Cart cleared success");
                resolve(data);
            }, "json").fail(err => reject(err))
        });
    }

    Shipping.AddToCart = function(id, quantity) {
        $.post("/cart/add.js", { id, quantity }, function (data) {
            console.log('Shipping: Added product to the cart');
            Shipping.carregaFrete();
        }, "json").fail(err => Shipping.onError(err))
    }

    Shipping.carregaFrete = function () {
        console.log('Shipping: Fetching CEP mapping');
        $.getJSON("//viacep.com.br/ws/" + Shipping.cep + "/json/?callback=?", function (dados) {
            if (!("erro" in dados)) {
                var state;
                var uf = dados.uf.toUpperCase();
                switch (uf) {
                    case "AC": state = "Acre"; break;
                    case "AL": state = "Alagoas"; break;
                    case "AM": state = "Amazonas"; break;
                    case "AP": state = "Amapá"; break;
                    case "BA": state = "Bahia"; break;
                    case "CE": state = "Ceará"; break;
                    case "DF": state = "Distrito Federal"; break;
                    case "ES": state = "Espírito Santo"; break;
                    case "GO": state = "Goiás"; break;
                    case "MA": state = "Maranhão"; break;
                    case "MG": state = "Minas Gerais"; break;
                    case "MS": state = "Mato Grosso do Sul"; break;
                    case "MT": state = "Mato Grosso"; break;
                    case "PA": state = "Pará"; break;
                    case "PB": state = "Paraíba"; break;
                    case "PE": state = "Pernambuco"; break;
                    case "PI": state = "Piauí"; break;
                    case "PR": state = "Paraná"; break;
                    case "RJ": state = "Rio de Janeiro"; break;
                    case "RN": state = "Rio Grande do Norte"; break;
                    case "RO": state = "Rondônia"; break;
                    case "RR": state = "Roraima"; break;
                    case "RS": state = "Rio Grande do Sul"; break;
                    case "SC": state = "Santa Catarina"; break;
                    case "SE": state = "Sergipe"; break;
                    case "SP": state = "São Paulo"; break;
                    case "TO": state = "Tocantíns"; break;
                }
                
                console.log('Shipping: Calculated state: ', state);
                Shipping.state = state;
                
                Shipping.prepareShippingRates()
            } else {
                Shipping.loading(false);
                Shipping.feedback(false, 'CEP não encontrado', true);
            }
        }).fail(function (jqXHR) {
            Shipping.feedback(false, 'Consulta de CEP indisponível no momento', true);
            Shipping.loading(false);
        });
    }

    Shipping.prepareShippingRates = function () {
        var shippingAddress = {};
        shippingAddress.zip = Shipping.cep;
        shippingAddress.country = Shipping.country;
        shippingAddress.province = Shipping.state;
    
        console.log('Shipping: Preparing shipping rates: ', shippingAddress);
    
        var params = {
            type: "POST",
            url: "/cart/prepare_shipping_rates",
            data: jQuery_T4NT.param({
                shipping_address: shippingAddress
            }),
            success: Shipping.syncShippingRates(),
            error: Shipping.onError
        };
    
        jQuery_T4NT.ajax(params); // Usando jQuery_T4NT para consistência
    };

    Shipping.syncShippingRates = function () {
        var poller = function () {
            jQuery_T4NT.ajax("/cart/async_shipping_rates", { // Usando jQuery_T4NT
                dataType: "json",
                success: function (response, textStatus, xhr) {
                    if (xhr.status === 200) {
                        Shipping.render(response.shipping_rates)
                    } else {
                        setTimeout(poller, 500)
                    }
                },
                error: Shipping.onError
            })
        };
        return poller
    };

    Shipping.feedback = function(success, message, disapear = false) {
        if (success) {
            $('#shipping-rates-feedback').removeClass('error').addClass('success');
        } else {
            $('#shipping-rates-feedback').removeClass('success').addClass('error');
        }

        $('#shipping-rates-feedback').html(message);

        if (disapear) {
            setTimeout(function() {
                $('#shipping-rates-feedback').html('');
            }, 2000);
        }
    }

    Shipping.render = function(rates) {

        let feedback = '';

        if (rates.length) {
            feedback = `Existem ${rates.length} tipos de frete disponíveis:`
        } else if (rates.length == 1) {
            feedback = `Existe um frete disponível.`
        } else {
            feedback = `Nós não entregamos para esse endereço.`;
        } 

        Shipping.feedback(true, feedback);

        for(var i = 0; i < rates.length; i++){
            Shipping.money = function(money) {
                if (money.indexOf('0.00') > -1) {
                    return 'Grátis'
                } 
        
                return geckoShopify.formatMoney(money);
            }

            let li = `<li>${ rates[i].name } - ${Shipping.money(rates[i].price)} -  Entregue em até: `;
            if (rates[i].delivery_days.length == 0) {
                li += `1 dia útil`
            } else {
                li += `${rates[i].delivery_days[0]} `
                li += rates[i].delivery_days[0] === 1 ? 'dia útil' : 'dias úteis'
            }
            li += `</li>`;
            $('#shipping-rates').append(li);
        }

        Shipping.loading(false);
    }

    Shipping.onError = function(error) {
        console.error(error);

        var feedback = "";
      
        if (error.responseJSON) {
            feedback = error.responseJSON.description;
        }

        Shipping.feedback(false, feedback, true);
        Shipping.loading(false);
    }

    Shipping.loading = function(load) {
        if (load) {
            $('.get-rates-custom').val('AGUARDE...').prop('disabled', true);
        } else {
            $('.get-rates-custom').val('CALCULAR').prop('disabled', false);
        }
    }
    
    geckoShopify.checkCepForProductPage = function () {
        Shipping.init();
        Shipping.cep = $('#address_zip').val();
        if (Shipping.cep.length != 9) {
            Shipping.feedback(false, 'Digite um CEP válido', true);
        } else {
            Shipping.loading(true);
            var variantid = $("#product-select_ppr").val();
            var quantity = +$('[name="quantity"]').val();

            console.log('Shipping: Add product to the cart', { variantid, quantity });

            jQuery_T4NT.getJSON('/cart.js', function (cart) { // Usando jQuery_T4NT.getJSON
                console.log('Shipping: Cart fetched');
                if (cart.item_count > 0) {
                    Shipping.clearCart().then(() => {
                        Shipping.AddToCart(variantid, quantity);
                    });
                } else {
                    Shipping.AddToCart(variantid, quantity);
                }
            });
        }
    }
})(jQuery_T4NT);

jQuery_T4NT(document).ready(function($) {
    $('.get-rates-custom').on('click', function(e) {
        geckoShopify.checkCepForProductPage();
    });
});
